import { render, staticRenderFns } from "./MyRecommendationsTableNew.vue?vue&type=template&id=0cc1851d&scoped=true"
import script from "./MyRecommendationsTableNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyRecommendationsTableNew.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyRecommendationsTableNew.vue?vue&type=style&index=0&id=0cc1851d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1851d",
  null
  
)

export default component.exports